import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import '../theme/index.css';
import './components/common/directives';
import './components/common/global.js';
import 'babel-polyfill';
import './util/rem';
import './assets/iconfont/iconfont.css';
import store from './store';
import core from './utils/core.js';
import echarts from 'echarts';
import BaiduMap from 'vue-baidu-map';
import config from '@/config';

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;
Vue.prototype.$core = core;
Vue.prototype.$config = config;
//百度地图
Vue.use(BaiduMap, {
    ak: 'eamhTz2SqvqGkXEW9Zg1kEhxmzR3Ag1e'
});
Vue.use(Viewer);
Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    }
});
Vue.use(VueI18n);
Vue.use(ElementUI);

// 定义混入函数处理数据预览
var myMixin = {
    methods: {
        handlerPreview: function(request) {
            request().then(res => {

            });
        }
    }
};


const i18n = new VueI18n({
    locale: 'zh',
    messages
});
new Vue({
    mixins: [myMixin],
    router,
    i18n,
    store,
    render: h => h(App)
}).$mount('#app');
